<template>
    <div class="tw-w-full md:tw-w-auto tw-flex tw-items-center tw-cursor-pointer tw-bg-grey-charcoal tw-py-7 tw-px-8 md:tw-py-0 md:tw-px-0 md:tw-bg-transparent md:tw-mr-4 tw-relative">

        <div class="tw-text-brown-grey hover:tw-text-brand-primary tw-flex tw-items-center" @click="isDropdownOpen = ! isDropdownOpen">
            <i class="fa fa-bell tw-mr-1"></i>
            <span>
                {{ "Informationen" }}
            </span>
            <div class="tw-absolute tw-bg-brand-primary tw-rounded-full"
                 style="width: 6px; height: 6px; top: 2px; left: 6px;"
                 v-show="hasUnreadNotifications"
            ></div>
        </div>

        <div id="notifications-dropdown"
             ref="notificationsDropdown"
             class="tw-absolute tw-bg-white tw-border tw-border-grey-pink tw-shadow tw-flex tw-flex-col tw-rounded md:tw-mt-4 tw-left-0 md:tw-left-auto tw-right-0 tw-z-10 tw-w-full md:tw-w-56"
             style="width: 360px; top: 100%;"
             v-show="isDropdownOpen"
        >
            <div ref="scrollContainer"
                 class="tw-w-full notification-box-scroll-area"
                 @scroll="closeContextMenu"
            >
                <div v-show="notifications.length > 0">
                    <div @click="markAllAsRead"
                         class="tw-text-sm tw-flex tw-justify-end tw-p-2 tw-text-brown-grey hover:tw-text-brand-primary"
                    >
                        {{ "Alle als gelesen markieren" }}
                    </div>

                    <div class="tw-flex tw-items-center tw-justify-start tw-py-3 hover:tw-bg-semilight-grey tw-relative"
                         @click="onNotificationClick($event, notification)"
                         @mouseenter="activeNotification = notification.id"
                         @mouseleave="activeNotification = null"
                         v-for="notification in notifications"
                         :ref="`notification-${notification.id}`"
                    >
                        <img :src="logoUrl(notification)" class="tw-object-cover tw-rounded-full tw-w-10 tw-h-10 tw-mx-3">

                        <div class="tw-flex-1">
                            <div class="tw-text-sm" v-html="notification.data.message"></div>
                            <div class="tw-text-sm tw-text-brand-primary" :title="notification.created_at | moment('DD.MM.YYYY HH:mm:ss')">
                                {{ notification.created_at_readable }}
                            </div>
                        </div>

                        <div class="tw-mx-3">
                            <div class="tw-bg-brand-primary tw-w-3 tw-h-3 tw-rounded-full" v-if="! notification.read_at"></div>
                        </div>

                        <div class="tw-absolute tw-right-0 tw-mr-8 tw-h-full tw-flex tw-items-center" v-show="activeNotification === notification.id || (contextMenuNotification && contextMenuNotification.id === notification.id)">
                            <button type="button" class="notification-action-button cu-btn-default-sm tw-w-8 tw-h-8 tw-inline-flex tw-items-center tw-justify-center" style="padding: 0 !important;" @click="contextMenuNotification = (contextMenuNotification === null || contextMenuNotification.id !== notification.id) ? notification : null">
                                ...
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="notifications.length === 0" class="tw-p-4">
                    Es sind aktuell keine Benachrichtigungen vorhanden.
                </div>
            </div>

            <div
                ref="actionContextMenu"
                class="tw-absolute tw-mr-8 tw-items-end tw-bg-white tw-border tw-border-slate-grey tw-flex tw-flex-col tw-rounded tw-z-50"
                :style="contextMenuPosition"
                v-if="contextMenuNotification !== null"
            >
                <div @click="markAsUnread(contextMenuNotification)"
                     v-show="contextMenuNotification.read_at"
                     class="tw-w-full tw-text-sm tw-whitespace-nowrap tw-text-slate-grey hover:tw-text-white hover:tw-bg-brand-primary focus:tw-bg-brand-primary active:tw-bg-brand-primary focus:tw-text-white active:tw-text-white tw-px-3 tw-py-2 tw-no-underline hover:tw-no-underline active:tw-no-underline focus:tw-no-underline tw-flex tw-items-center"
                >
                    <i class="fa fa-check"></i>
                    <span class="tw-ml-2">{{ "Als ungelesen markieren" }}</span>
                </div>

                <div @click="markAsRead(contextMenuNotification)"
                     v-show="! contextMenuNotification.read_at"
                     class="tw-w-full tw-text-sm tw-whitespace-nowrap tw-text-slate-grey hover:tw-text-white hover:tw-bg-brand-primary focus:tw-bg-brand-primary active:tw-bg-brand-primary focus:tw-text-white active:tw-text-white tw-px-3 tw-py-2 tw-no-underline hover:tw-no-underline active:tw-no-underline focus:tw-no-underline tw-flex tw-items-center"
                >
                    <i class="fa fa-check"></i>
                    <span class="tw-ml-2">{{ "Als gelesen markieren" }}</span>
                </div>

                <div @click="deleteNotification(contextMenuNotification)"
                     class="tw-w-full tw-text-sm tw-whitespace-nowrap tw-text-slate-grey hover:tw-text-white hover:tw-bg-brand-primary focus:tw-bg-brand-primary active:tw-bg-brand-primary focus:tw-text-white active:tw-text-white tw-px-3 tw-py-2 tw-no-underline hover:tw-no-underline active:tw-no-underline focus:tw-no-underline tw-flex tw-items-center"
                >
                    <i class="fa fa-trash"></i>
                    <span class="tw-ml-2">{{ "Benachrichtigung löschen" }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotificationBox',

        props: {
            user: {
                required: true,
                type: Object,
            }
        },

        data() {
            return {
                isDropdownOpen: false,
                notifications: [],
                activeNotification: null,
                contextMenuNotification: null,
                containerScrollY: 0,
            }
        },

        computed: {
            hasUnreadNotifications() {
                return this.notifications
                    .filter(notification => {
                        return ! notification.read_at;
                    })
                    .length > 0;
            },

            contextMenuPosition() {
                if (! this.contextMenuNotification) {
                    return {};
                }

                const notificationEl = this.$refs[`notification-${this.contextMenuNotification.id}`][0];
                const notificationHeight = notificationEl.getBoundingClientRect().height;
                const notificationOffsetTop = notificationEl.offsetTop;
                const yPosition = notificationOffsetTop + (notificationHeight / 2) + 18 - this.containerScrollY;

                return {
                    right: 0 + 'px',
                    top: yPosition + 'px',
                };
            },
        },

        methods: {
            close() {
                this.isDropdownOpen = false;
            },

            closeContextMenu() {
                this.contextMenuNotification = null;
            },

            initEvents() {
                const handleOutsideClick = (e) => {
                    e.stopPropagation();

                    if (! this.$el.contains(e.target) && document.contains(e.target) && e.target !== this.$refs.button) {
                        this.close();
                        this.closeContextMenu();
                    }
                }

                document.addEventListener('click', handleOutsideClick);
                document.addEventListener('touchstart', handleOutsideClick);

                this.$refs.scrollContainer.addEventListener('scroll', () => {
                    this.containerScrollY = this.$refs.scrollContainer.scrollTop;
                });
            },

            fetchNotifications() {
                axios.get(`/notifications`).then(response => this.notifications = response.data);
            },

            markAllAsRead() {
                axios.post(`/notifications/mark-all-as-read`).then(() => {
                    this.fetchNotifications();
                });
            },

            updateNotification(notification) {
                this.notifications = this.notifications.map(currentNotification => {
                    if (currentNotification.id === notification.id) {
                        return notification;
                    }
                    return currentNotification;
                });
            },

            onNotificationClick(e, notification) {
                if (e.target.classList.contains('notification-action-button')) {
                    return;
                }

                if (notification?.data?.action_url) {
                    if (!notification?.data?.read_at) {
                        this.markAsRead(notification, () => {
                            window.location = notification.data.action_url;
                        });
                    } else {
                        window.location = notification.data.action_url;
                    }
                }
            },

            markAsUnread(notification, callback) {
                this.toggleRead(notification, false, callback);
            },

            markAsRead(notification, callback) {
                this.toggleRead(notification, true, callback);
            },

            toggleRead(notification, isRead, callback) {
                this.contextMenuNotification = null;

                axios
                    .patch(`/notifications/${notification.id}`, {
                        isRead: isRead
                    })
                    .then(response => {
                        this.updateNotification(response.data);
                        if (typeof callback === 'function') {
                            callback();
                        }
                    })
                    .catch(error => {
                        alert('Error!');
                    });
            },

            deleteNotification(notification) {
                this.contextMenuNotification = null;

                axios
                    .delete(`/notifications/${notification.id}`)
                    .then(response => {
                        this.notifications = this.notifications.filter(currentNotification => {
                            return currentNotification.id !== notification.id;
                        });
                    })
                    .catch(error => {
                        alert('Error!');
                    });
            },

            logoUrl(notification) {
                return notification?.data?.logo_url ?? '/img/doegel-logo-small.png';
            },
        },

        mounted() {
            this.initEvents();
            this.fetchNotifications();
        }
    }
</script>

<style scoped>
    .notification-box-scroll-area {
        max-height: 400px;
        overflow-y: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .notification-box-scroll-area::-webkit-scrollbar {
        display: none;
    }
</style>
